import get from 'lodash/get';
import spacingDecisions from '@classify/design-tokens/spacing';

export const getSpacing = (spacings: typeof spacingDecisions | {}) => (factor: string | number) => {
  if (typeof factor === 'number') {
    return `${(factor * 8) / 16}rem`;
  }
  return get(spacings, factor) || factor;
};

const spacing = getSpacing(spacingDecisions);

export default spacing;
